import { Card, CardActions, CardContent, CardHeader, IconButton, ListItem, ListItemText, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { commonStyles } from "../assets/styles/commonStyles";

// Styled Components using common styles
export const StyledCard = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'visible'
})<{ visible: boolean }>(({ theme, visible }) => ({
    ...commonStyles.enhancedCard(theme),
    ...commonStyles.standardCardDimensions(theme),
    padding: theme.spacing(2),
    display: visible ? 'flex' : 'none',
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
    '& .MuiCardHeader-title': {
        ...commonStyles.responsiveText(theme),
        [theme.breakpoints.up('md')]: {
            fontSize: '1.25rem',
        },
    },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
    overflow: 'auto',
    paddingTop: 0,
    marginTop: theme.spacing(-2),
    flex: 1,
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
    ...commonStyles.enhancedListItem(theme),
}));

export const StyledDeleteButton = styled(IconButton)(({ theme }) => ({
    ...commonStyles.enhancedButton(theme),
}));

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
    alignSelf: "stretch",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    
    [theme.breakpoints.up('sm')]: {
        flexWrap: 'nowrap',
    },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    fontSize: '0.75rem',
    padding: '6px 12px',
    
    [theme.breakpoints.up('sm')]: {
        fontSize: '0.875rem',
        padding: '8px 16px',
    },
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
    '& .MuiListItemText-primary': {
        ...commonStyles.responsiveText(theme),
    },
    '& .MuiListItemText-secondary': {
        fontSize: '0.75rem',
        [theme.breakpoints.up('sm')]: {
            fontSize: '0.875rem',
        },
    },
}));
